import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';

export const getCitiesList = query => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cities
      .getCitiesList(query)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_CITIES_LIST_FAILED,
            reject: actionTypes.GET_CITIES_LIST_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.GET_CITIES_LIST_LOADING);
  const success = res => action(actionTypes.GET_CITIES_LIST_SUCCESS, res);

  return request();
};

export const getCityById = (id) => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cities
      .getCityById(id)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_CITY_BY_ID_FAILED,
            reject: actionTypes.GET_CITY_BY_ID_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.GET_CITY_BY_ID_LOADING);
  const success = res => action(actionTypes.GET_CITY_BY_ID_SUCCESS, res);

  return request();
};

export const updateCity = (reqObject, id) => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cities
      .updateCity(reqObject, id)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.UPDATE_CITY_FAILED,
            reject: actionTypes.UPDATE_CITY_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.UPDATE_CITY_LOADING);
  const success = res => action(actionTypes.UPDATE_CITY_SUCCESS, res);

  return request();
};

export const addNewCity = (reqObject) => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.cities
      .addNewCity(reqObject)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.ADD_NEW_CITY_FAILED,
            reject: actionTypes.ADD_NEW_CITY_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.ADD_NEW_CITY_LOADING);
  const success = res => action(actionTypes.ADD_NEW_CITY_SUCCESS, res);

  return request();
};